import React from 'react';
import {Button} from "antd";
import styled from "styled-components";
import {StyledModal} from "./StyledModal";

const CancelButton = styled(Button)`
  padding: 8px 24px 8px 24px;
  border-radius: 4px;
  color : #45505A;
  border: 1px solid #A9B3BC;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  height: 100%;
  &:hover {
    border-color: #A9B3BC !important;
    color: #76838F !important;
  }
`

const OkButton = styled(Button)`
  &:hover {
    background-color: #56ADF3 !important;
  }
`

type PublishingWithEmptyInfoModalProps = {
  isOpen: boolean,
  close: () => void,
  handleNavigate: () => void
}

export const PublishingWithEmptyInfoModal = ({isOpen, close, handleNavigate} : PublishingWithEmptyInfoModalProps) => {

  return(
    <StyledModal
      open={isOpen}
      title="Невозможно опубликовать резюме"
      onOk={handleNavigate}
      onCancel={close}
      centered
      footer={[
        <CancelButton onClick={close} key="back">
          Отмена
        </CancelButton>,
        <OkButton type="primary" onClick={handleNavigate} key="submit">
          Заполнить резюме
        </OkButton>
      ]}
    >
      <p>Чтобы опубликовать резюме, Вам необходимо сначала заполнить всю информацию о себе</p>
    </StyledModal>
  )
}